import { Navigate } from 'react-router-dom';
import AppRoutes from '../../enums/app-routes';
import { GetAccessToken } from '../../functions/session-functions';
import UnprotectedRouteProps from './unprotected-route-props';

const UnprotectedRoute = ({ children }: UnprotectedRouteProps): React.JSX.Element => {
	if (GetAccessToken()) {
		return <Navigate to={AppRoutes.Dashboard} replace />;
	}

	return children;
};

export default UnprotectedRoute;
